import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-912d11f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time" }
const _hoisted_2 = { class: "duration" }
const _hoisted_3 = {
  key: 0,
  class: "price"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_DepartureTicketType = _resolveComponent("DepartureTicketType")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["departure-item", { selected: _ctx.selected, 'departure-item--disabled': _ctx.departure.disabled || !_ctx.departure.bookable }])
  }, [
    _createElementVNode("div", {
      class: "header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectDeparture && _ctx.selectDeparture(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.departure.fromDestination), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.HHmm(_ctx.departure.departureDate)), 1),
        _createVNode(_component_BaseSvg, { icon: 'arrow/arrow-short-right' }),
        _createElementVNode("span", null, _toDisplayString(_ctx.departure.toDestination), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.HHmm(_ctx.departure.arrivalDate)), 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getDurationInMinutes(_ctx.departure.departureDate, _ctx.departure.arrivalDate)) + "m", 1)
      ]),
      (_ctx.departure.bookable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", null, "£ " + _toDisplayString(_ctx.departure.price.toFixed(2)), 1)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.departure.message), 1))
    ]),
    (_ctx.displayAlternatives)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departure.ticketTypes, (ticketType, index) => {
            return (_openBlock(), _createBlock(_component_DepartureTicketType, {
              key: index,
              id: ticketType.id,
              name: `tt-${_ctx.direction}`,
              value: ticketType.id,
              ticket: ticketType,
              disabled: !ticketType.bookable,
              modelValue: _ctx.ticketTypeInput,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ticketTypeInput) = $event))
            }, null, 8, ["id", "name", "value", "ticket", "disabled", "modelValue"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}